export default __webpack_public_path__ + "static/media/24.83562b79.png";